import { useState } from "react"
import { Link } from "react-router-dom"

import useFlashMessage from '../../../hooks/useFlashMessage'

//functions
import NumberToMoney from '../../../shared/functions/NumberToMoney'
import "../SimpleProduct.css"
/* form */
import Input from "../../../shared/components/form/input"
import FormLayout from "../../../shared/components/FormLayout/FormLayout"
import FormSection from "../../../shared/components/FormLayout/FormSection"
import Button from "../../../shared/components/Button/Button"
/* form select */
import Select from 'react-select'
import selectStyles from "../../../shared/css/SelectStyle"

function FormSimpleProduct({ simpleProductData, handleSubmit, title, btCancelLink, btnText, btCancelAction }) {
    const simpleProductDefault = {
        cost: "0.00",
        unit: { label: "unidade", name: "unit", value: "unit" },
    }

    const [simpleProduct, setSimpleProduct] = useState(simpleProductData || simpleProductDefault)

    function handleChange(e) {
        setSimpleProduct({ ...simpleProduct, [e.target.name]: e.target.value })
    }
    /* ------------------------------------- SELECT ---------------------------------------- */
    const handleSelectChange = (selectedOption) => {
        setSimpleProduct({ ...simpleProduct, [selectedOption.selectName]: selectedOption })
    }

    /* ----------------- function  money 0.00 ------------------- */
    function handleChangeMoney(e) {
        let value = NumberToMoney(e.target.value)
        setSimpleProduct({ ...simpleProduct, [e.target.name]: value })
    }

    /* -------------------------------------- Submit --------------------------------------- */
    function submit(e) {
        e.preventDefault()

        let data = simpleProduct

        data.totalInCash = NumberToMoney(simpleProduct.inCash)
        data.totalInstalment = NumberToMoney(simpleProduct.instalment)

        handleSubmit(data)
    }

    /* --------------------------------- page ------------------------------------------ */
    return (
        <FormLayout
            title={title}
            onSubmit={submit}
            actions={
                <>
                    <Button variant="save" type="submit">{btnText || 'Salvar'}</Button>
                    {btCancelLink
                        ? <Link className="link-default" to={btCancelLink}><Button variant="cancel">Cancelar</Button></Link>
                        : btCancelAction && <Button variant="cancel" onClick={btCancelAction}>Cancelar</Button>
                    }
                </>
            }
        >
            <FormSection label="Identificação">
                <div className="fl-row">
                    <div className="fl-col-narrow form-group">
                        <Input
                            text="Código"
                            type="text"
                            name="code"
                            disabled={true}
                            handleOnChange={handleChange}
                            value={simpleProduct.code || ''}
                        />
                    </div>
                    <div className="fl-col-narrow form-group">
                        <Input
                            text="NCM"
                            type="text"
                            name="ncm"
                            handleOnChange={handleChange}
                            value={simpleProduct.ncm || ""}
                        />
                    </div>
                    <div className="fl-col-wide form-group">
                        <Input
                            text="Descrição"
                            type="text"
                            name="description"
                            placeholder="digite uma descrição"
                            handleOnChange={handleChange}
                            value={simpleProduct.description}
                            disabled={false}
                        />
                    </div>
                </div>
            </FormSection>

            <FormSection label="Precificação">
                <div className="fl-row">
                    <div className="fl-col-narrow form-group">
                        <Input
                            text="Custo"
                            type="number"
                            name="cost"
                            handleOnChange={handleChange}
                            handleOnBlur={handleChangeMoney}
                            value={simpleProduct.cost}
                        />
                    </div>
                    <div className="fl-col-narrow form-group">
                        <label className="input-label">Unidade:</label>
                        <Select
                            options={[
                                { selectName: "unit", value: "unit", label: "unidade" },
                                { selectName: "unit", value: "box", label: "caixa" },
                                { selectName: "unit", value: "kit", label: "kit" },
                                { selectName: "unit", value: "m", label: "Metro" },
                                { selectName: "unit", value: "kg", label: "Quilo" },
                            ]}
                            styles={selectStyles}
                            onChange={handleSelectChange}
                            value={simpleProduct.unit}
                            menuPortalTarget={document.body}
                            menuPosition="fixed"
                        />
                    </div>
                    <div className="fl-col-narrow form-group">
                        <Input
                            text="Preço à Vista"
                            type="number"
                            name="inCash"
                            handleOnChange={handleChange}
                            handleOnBlur={handleChangeMoney}
                            value={simpleProduct.inCash}
                        />
                    </div>
                    <div className="fl-col-narrow form-group">
                        <Input
                            text="Preço Parcelado"
                            type="number"
                            name="instalment"
                            handleOnChange={handleChange}
                            handleOnBlur={handleChangeMoney}
                            value={simpleProduct.instalment}
                        />
                    </div>
                </div>
            </FormSection>
        </FormLayout>
    )
}

export default FormSimpleProduct
